import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material'
import { UseFormSetValue } from 'react-hook-form'

import { Gender } from '@/clients/utoniq-core/schema'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

import { SettingValues } from '../PersonalInfoForm'

type GenderInputCellProps = {
  value: SettingValues['gender']
  isRequired?: boolean
  setValue: UseFormSetValue<SettingValues>
}

export const GenderInputCell: Cell<GenderInputCellProps> = ({
  value,
  isRequired,
  setValue,
}) => {
  const { t } = useTranslation('personalInfoSettings')
  return (
    <CellFrame sx={{ pt: 6, mb: 4 }}>
      <Stack direction="row" alignItems="center">
        <Typography variant="subtitle1" color="text.secondary">
          {t('gender', '性別')}
        </Typography>
        {isRequired && (
          <Typography
            variant="caption"
            color="error.main"
            component="p"
            ml={1}
            mt={-1}
          >
            {t('required', '※必須')}
          </Typography>
        )}
      </Stack>
      <RadioGroup
        value={value}
        onChange={(_, value) =>
          setValue('gender', value as Gender, {
            shouldDirty: true,
            shouldValidate: true,
          })
        }
        sx={{ display: 'flex', flexDirection: 'row', gap: 3 }}
      >
        {[Gender.Male, Gender.Female, Gender.None].map(gender => (
          <FormControlLabel
            value={gender}
            key={gender}
            control={<Radio />}
            label={t(gender)}
          />
        ))}
      </RadioGroup>
    </CellFrame>
  )
}
